module.exports = __webpack_public_path__ + "3ce30c5b7c296f4b05a6817bc4eb08b8.jpg";